import { render, staticRenderFns } from "./table-list.vue?vue&type=template&id=4c741128"
import script from "./table-list.vue?vue&type=script&lang=js"
export * from "./table-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports